import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import { PAY_ESTIMATE } from "../_constants/actionConstants";
import { actionScripts } from "../_helpers/actionScripts";
import { getUUID } from "../_utils/generalUtils";

const fetchList = (projectId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: PAY_ESTIMATE.FETCH_LIST, projectId });
    axios
      .get(`${BASE_URL}/api/PayEstimates/List/${projectId}`)
      .then((response) => {
        dispatch({
          type: PAY_ESTIMATE.FETCH_LIST_FULFILLED,
          projectId,
          payload: response.data,
        });
        resolve(response.data);
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PAY_ESTIMATE.FETCH_LIST_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: PAY_ESTIMATE.FETCH_LIST_REJECTED, projectId });
        reject(err);
      });
  });

const fetchDetail = (payEstimateId, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: PAY_ESTIMATE.FETCH_DETAIL, tabId });
    axios
      .get(`${BASE_URL}/api/PayEstimates/${payEstimateId}`)
      .then((response) => {
        dispatch({
          type: PAY_ESTIMATE.FETCH_DETAIL_FULFILLED,
          tabId,
          payload: response.data,
        });
        resolve(response.data);
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PAY_ESTIMATE.FETCH_DETAIL_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: PAY_ESTIMATE.FETCH_DETAIL_REJECTED, tabId });
        reject(err);
      });
  });

const createEstimate = (dto, projectId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: PAY_ESTIMATE.CREATE });
    axios
      .post(`${BASE_URL}/api/PayEstimates`, dto)
      .then((response) => {
        dispatch({
          type: PAY_ESTIMATE.CREATE_FULFILLED,
          projectId,
          newEstimateId: response.data,
        });
        resolve(response.data);
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PAY_ESTIMATE.CREATE_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: PAY_ESTIMATE.CREATE_REJECTED });
        reject(err);
      });
  });

const closeEstimate = (payEstimateId, closedByUserId, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: PAY_ESTIMATE.CLOSE, tabId });
    axios
      .post(`${BASE_URL}/api/PayEstimates/${payEstimateId}/Close`, { closedByUserId })
      .then(() => {
        dispatch({ type: PAY_ESTIMATE.CLOSE_FULFILLED, tabId, payEstimateId });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PAY_ESTIMATE.CLOSE_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: PAY_ESTIMATE.CLOSE_REJECTED, tabId });
        reject(err);
      });
  });

const deleteEstimate = (payEstimateId, projectId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: PAY_ESTIMATE.DELETE });
    axios
      .delete(`${BASE_URL}/api/PayEstimates/${payEstimateId}`)
      .then(() => {
        dispatch({ type: PAY_ESTIMATE.DELETE_FULFILLED, payEstimateId, projectId });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PAY_ESTIMATE.DELETE_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: PAY_ESTIMATE.DELETE_REJECTED });
        reject(err);
      });
  });

const fetchReportedItems = (payEstimateId, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: PAY_ESTIMATE.FETCH_REPORTED_ITEMS, tabId });
    axios
      .get(`${BASE_URL}/api/PayEstimates/${payEstimateId}/ReportedItems`)
      .then((response) => {
        dispatch({
          type: PAY_ESTIMATE.FETCH_REPORTED_ITEMS_FULFILLED,
          tabId,
          payload: response.data,
        });
        resolve(response.data);
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PAY_ESTIMATE.FETCH_REPORTED_ITEMS_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: PAY_ESTIMATE.FETCH_REPORTED_ITEMS_REJECTED, tabId });
        reject(err);
      });
  });

const prepopulateQSheets = (payEstimateId, createdByUserId, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: PAY_ESTIMATE.PREPOPULATE_QSHEETS, tabId });
    axios
      .post(`${BASE_URL}/api/PayEstimates/${payEstimateId}/PrepopulateQSheets`, { createdByUserId })
      .then((response) => {
        dispatch({
          type: PAY_ESTIMATE.PREPOPULATE_QSHEETS_FULFILLED,
          tabId,
          payload: response.data,
        });
        resolve(response.data);
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PAY_ESTIMATE.PREPOPULATE_QSHEETS_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: PAY_ESTIMATE.PREPOPULATE_QSHEETS_REJECTED, tabId });
        reject(err);
      });
  });

const payEstimateActions = {
  fetchList,
  fetchDetail,
  createEstimate,
  closeEstimate,
  deleteEstimate,
  fetchReportedItems,
  prepopulateQSheets,
};

export default payEstimateActions;
